import React, { useEffect, useState, Fragment } from 'react'
import { Col, Container, Form, Row} from 'react-bootstrap'
import { useDispatch, useSelector} from 'react-redux'
import { obtenerUrlCarpeta } from '../../store/actions/carpeta-digital-ation'
import {LoadingComponent} from 'recupero-comunes'

const VisorCarpeta = ({prototipo, idImplicado, setSendUrl, docRef, sendUrl, region}) => {

  const [loading, setLoading]=useState(false)
  const [value, setValue] = useState([1]);
  const [query, setQuery] = useState('');
  const [codDocumento, setCodDocumento] = useState('');
  const data_carpeta = useSelector((state) => state.carpetaDigitalReducer)
  const { cfg_form30,comboDocumentos, limpiar} = data_carpeta
  const data_recepciona = useSelector((state) => state.casoGeneralReducer)
  const { llaves} = data_recepciona
  const dispatch=useDispatch()
  const handleChange = (val) => setValue(val); 

  useEffect(()=>{

    setCodDocumento('')
  },[limpiar])
  
  return (
    <>
    <LoadingComponent show={loading}/>
      <Container>
            {cfg_form30? (
                <div >
                  
                  <Row  >                 
                    <Col md='3'>
                        </Col>
                    <Col md='2'>
                      <Form.Label className='mb-2 mt-5' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {
                          cfg_form30.cfg_form30[
                            'modalcd-cmb-tipodocto'
                          ]
                        }
                      </Form.Label>                   
                    </Col>
                    <Col md="4">
                    <Form.Select
                        className='mt-5'
                        aria-label='Default select example' 
                        style={{marginTop:sendUrl!==''?'0px':'20px'}}                 
                        onChange={(e) => {
                          setLoading(true)
                          setCodDocumento(e.target.value)
                          setSendUrl('')
                          const op='cd-upload'
                          let localQuery=''
                          if(comboDocumentos){
                            localQuery = new Buffer(`op=${op}&dockey=${llaves && llaves["idCaso"]}&docsubkey=${idImplicado}&doctype=${comboDocumentos && comboDocumentos.comboDocumentos.filter(c=>c.Id===parseInt(e.target.value))[0].uso}&owner=${llaves && llaves['idOrgCaso']}&user=${llaves && llaves['idUsuario']}&filename=${comboDocumentos && comboDocumentos.comboDocumentos.filter(c=>c.Id===parseInt(e.target.value))[0].uso}_${llaves && llaves['idUsuario']}&filetypes=${comboDocumentos && comboDocumentos.comboDocumentos.filter(c=>c.Id===parseInt(e.target.value))[0].formato}&region=${region}&origenusr=1`)
                          }
                          setQuery(localQuery.toString('base64'))
                          dispatch(obtenerUrlCarpeta(localQuery.toString('base64')))
                          setLoading(false)
                          
                        }}
                        disabled={prototipo===3}
                        name='codHitoCambioGestion'
                         value={prototipo!==3?codDocumento:docRef.Id}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboDocumentos && prototipo!==3 ?
                          comboDocumentos.comboDocumentos?.map((c) => (
                            <option key={c.Id} value={c.Id}>
                              {c.nombre}
                            </option>
                          )):docRef!==undefined ?<option key={docRef && docRef.Id} value={docRef && docRef.Id}>
                          {docRef.nombre}
                        </option>:''}
                      </Form.Select>
                    </Col>
                  </Row>               
                  <Row>
                    <Col>
                    <div style={{height:'30px'}}></div>
                    </Col>
                  </Row>      
                </div>
            ) : null}            
      </Container>
    </>
  )
}
export default VisorCarpeta
